import { useMutation } from 'react-query';
import api from '../api';

const getWebhookResponseBodyByResponseId = async ({
  workspaceName,
  modelName,
  responseId
}) => {
  return await api.post('/registry/model/webhook/response', {
    workspaceName,
    modelName,
    responseId
  });
};

export const useGetWebhookResponseBodyByResponseId = (config = {}) => {
  return useMutation(
    ({ workspaceName, modelName, responseId }) =>
      getWebhookResponseBodyByResponseId({
        workspaceName,
        modelName,
        responseId
      }),
    config
  );
};
